var resumeData = {
	"imagebaseurl": "https://princelle.org/fr",
	"lang": "fr",
	"langs": [
		["/fr", "🇫🇷 Français"],
		["/en", "🇺🇸 English (not updated yet)"]
	],
	"changeLang": "Changer de langue ?",
	"welcome": "Bienvenue !",
	"name": "Je suis Maxime Princelle.",
	"roleDescription": [
		"Développeur",
		"Ingénieur DevOps",
		"Administrateur Système",
		//"Étudiant en Informatique"
		//"Chercheur de Solutions"
	],
	"socialLinks": [
		/**{
			"name": "blog",
			"url": "https://blog.princelle.org",
			"className": "fas fa-blog"
		}, */
		{
			"name": "twitter",
			"url": "https://twitter.com/ThePrincelle",
			"className": "fab fa-twitter"
		},
		{
			"name": "facebook",
			"url": "https://www.facebook.com/ThePrincelle",
			"className": "fab fa-facebook-f"
		},
		/* {
			"name": "snapchat",
			"url": "https://www.snapchat.com/add/princellemaxime",
			"className": "fab fa-snapchat"
		}, */
		{
			"name": "instagram",
			"url": "https://www.instagram.com/theprincelle/",
			"className": "fab fa-instagram"
		},
		{
			"name": "linkedin",
			"url": "https://fr.linkedin.com/in/maxime-princelle",
			"className": "fab fa-linkedin"
		},
		{
			"name": "git",
			"url": "https://github.com/ThePrincelle",
			"className": "fab fa-github"
		},
		{
        	"name": "gitlab",
        	"url": "https://git.unistra.fr/princelle",
        	"className": "fab fa-gitlab"
		},
		/**{
			"name": "applemusic",
			"url": "https://music.apple.com/profile/ThePrincelle",
			"className": "fas fa-music"
		}*/
	],
	"aboutme": [
		"Je suis principalement intéressé par le domaine des nouvelles technologies, du web, de l'intelligence artificielle et des maisons intelligentes.",
		"Sur mon temps personnel, j'ai mis au point un système complet de domotique et j'ai eu par ce biais l'occasion de me perfectionner sur différents systèmes.",
		"Bien que passant la majorité de mon temps sur un ordinateur, je pratique également d'autres activités tels que le piano et le chant."
	],
	"moreme": [
		{
			"name": "Objectifs",
			"icon": "fas fa-bullseye",
			"text": "Mon objectif, pour le moment, consiste à apprendre un maximum de chose lors de mes études afin de me préparer le mieux possible pour le monde du travail et la vie active. Chaque année d'alternance, chaque stage, consiste pour moi en un challenge afin de m'adapter au mieux à la demande et à continuer d'avantage l'approfondissement de mes connaissances."
		},
		{
			"name": "Créativité",
			"icon": "fas fa-pencil-ruler",
			"text": "Le monde de l'informatique est en soi, pour moi, en demande constante de créativité. Malgré le fait que le langage soit commun, il ne faut selon mon avis, jamais arrêter d'innover afin de permettre à un logiciel ou un système de rester le plus innovant, le plus longtemps possible."
		},
		{
			"name": "Travail en équipe",
			"icon": "fas fa-users",
			"text": "Le travail en équipe est pour moi, quelque chose de primordial. Car comme l'avait dit Steve Jobs : \"Les meilleures choses qui arrivent dans le monde de l’entreprise ne sont pas le résultat du travail d’ un seul homme. C’est le travail de toute une équipe.\". Et c'est là, tout l'intérêt du travail en équipe."
		},
		{
			"name": "Apprendre",
			"icon": "fas fa-graduation-cap",
			"text": "Dans ce domaine, l'informatique, on ne doit jamais cesser d'apprendre, que ce soit de nouvelles méthodes de programmation ou tout simplement un nouveau langage, la personne qui apprends dans ce domaine, doit maintenir une veille technologique constante tout en continuant de s'améliorer en s'investissant au maximum dans un projet."
		}
	],
	"eduDesc": [
		"Vous trouverez ici, les différentes formations que j'ai suivi.",
		"L'un de mes objectifs étant d'apprendre, je pense qu'il est important de bien se former et de se préparer un maximum avant d'intégrer la vie active."
	],
	"learnmore": "En savoir plus...",
	"education": [
		{
			"name": "UFR de mathématiques et informatique - Master Informatique SIL",
			"loc": "Illkirch, France",
			"locLink": "https://goo.gl/maps/iCC4UxwmpbYTx5L66",
			"date": "2020 - aujourd'hui",
			"desc": [
				"Master Informatique : Science et Ingénierie du Logiciel.",
				"Je suis cette formation en alternance afin d'approfondir mes connaissances sur l'algorithmique distribuée (Erlang), les technologies web (PHP, JavaScript, etc.), et mobiles (React Native, Flutter), et enfin objets (C++), etc.",
				"En parallèle de la partie 'Informatique', j'ai suivi des cours sur la gestion et conduite de projet, mais également la vie professionnelle (Communication, Droit, Outils de gestion, Qualité, etc.).",
				"Enfin, j'ai pu réaliser plusieurs projets tels qu'un travail d'étude et de recherche sur le tri d'emails via Machine Learning, ou encore un projet de développement d'une interface en réalité virtuelle pour l'analyse et l'étude de données via le langage R."
			],
			"link": "https://mathinfo.unistra.fr/formations/master/informatique/science-et-ingenierie-du-logiciel-sil/"
		},
		{
			"name": "IUT Robert Schuman - Licence Pro CDAD",
			"loc": "Illkirch, France",
			"locLink": "https://goo.gl/maps/CJP6MMdss9kCzqgH7",
			"date": "2019 - 2020",
			"desc": [
				"Licence Professionnelle : Conception et Développement d'Applications Distribuées. Voilà le titre de la formation en alternance que je suis. J'y apprends le fonctionnement et la configuration de serveurs ainsi que le développement plus en profondeur de site web et d'applications mobiles Android."
			],
			"link": "http://iutrs.unistra.fr/"
		},
		{
			"name": "IUT Robert Schuman - DUT Informatique",
			"loc": "Illkirch, France",
			"locLink": "https://goo.gl/maps/CJP6MMdss9kCzqgH7",
			"date": "2017 - 2019",
			"desc": [
				"J'y apprends différents langages de programmation ainsi que l'algorithmique et le fonctionnement des systèmes mais aussi la gestion de projets tout en se préparant au monde de l'entreprise."
			],
			"link": "http://iutrs.unistra.fr/"
		},
		{
			"name": "Lycée Louis Marchal",
			"loc": "Molsheim, France",
			"locLink": "https://goo.gl/maps/hsTS1XKXLcGLAUTr6",
			"date": "2014 - 2017",
			"desc": [
				"J'y ai suivi la formation STI2D (Sciences et Technologies de l'Industrie et du Développement Durable) spécialité SIN (Système d'Information et Numérique).",
				"J'ai participé à la vie du lycée à travers l'association \"Maison des Lycéens\" mais également en étant délégué et membre du CVL (Conseil de la Vie Lycéenne).",
				"J'ai obtenu mon baccalauréat avec mention \"Très bien\"."
			],
			"link": "http://www.lycee-marchal.com/"
		},
		{
			"name": "Collège Louis Arbogast",
			"loc": "Mutzig, France",
			"locLink": "https://goo.gl/maps/QFgEU6aUsiZpVL6H9",
			"date": "2010 - 2014",
			"desc": [
				"Durant ces quatre années, je me suis investi dans la vie associative et contribué à plusieurs évènements (Concert de fin d 'année, Journée Portes Ouvertes,...).",
				"Dans le même temps, j'ai préparé au mieux mon entrée au lycée et j'ai obtenu mon brevet.",
			],
			"link": "http://www.education.gouv.fr/annuaire/67-bas-rhin/mutzig/college/college-louis-arbogast.html"
		}
	],
	"workDesc": [
		"Vous trouverez ici, les différentes expériences professionnelles que j'ai acquises."
	],
	"work": [
		{
			"name": "Numesia",
			"loc": "Strasbourg, France",
			"locLink": "https://goo.gl/maps/5RPbdKcjJXddsSmQA",
			"date": "2020 - aujourd'hui",
			"desc": [
				"A l'occasion de mon alternance lors de mon Master SIL, j'ai décidé de continuer dans une entreprise de petite taille.",
				"J'ai eu l'occasion de travailler sur des technologies du type Kubernetes et d'approfondir mes connaissances sur la conteneurisation d'application avec Docker.",
				"Dans le même temps j'ai contribué sur les applications de l'entreprise, que ce soit du côté du développement avec des technologies comme Laravel (PHP) et VueJS.",
				"On m'a également confié des missions sur la partie DevOps et Administration Système. Avec la mise en place d'un nouveau procédé de build d'image Docker permettant ainsi de gagner du temps sur les mises en production.",
				"Enfin, j'ai mis en place un outil de monitoring basé sur mon logiciel de domotique (Home Assistant) permettant ainsi de réduire les coûts et le nombre d'outils utilisé."
			],
			"link": "https://www.numesia.fr/"
		},
		{
			"name": "Ubertone",
			"loc": "Schiltigheim, France",
			"locLink": "https://goo.gl/maps/5RPbdKcjJXddsSmQA",
			"date": "2019 - 2020",
			"desc": [
				"A l'occasion de mon alternance lors de ma licence professionnelle, j'ai décidé de viser une entreprise du type start-up.",
				"J'ai participé à la création d'un 'Cloud' permettant aux clients de réaliser de lancer des analyses à partir des données obtenues d'appareils de mesure Ubertone.",
				"Ce projet m'a permis d'approfondir mes connaissances sur Python et l'analyse de données, JavaScript, et enfin PostgreSQL et la conception d'une architecture de base de données optimisée."
			],
			"link": "https://ubertone.com"
		},
		{
			"name": "Solu-Tech",
			"loc": "Rosheim, France",
			"locLink": "https://goo.gl/maps/jejsTAkaHi52s8rg9",
			"date": "2019 (4 mois)",
			"desc": [
				"A l'occasion de mon stage lors de mon DUT, j'ai décidé de retourner chez Solu-Tech.",
				"Ma mission était d'améliorer le site intranet permettant de gérer les heures et les frais des employés.",
				"Afin de répondre à ce besoin, j'ai décidé de reprendre le site à zéro pour pouvoir développer une API en NodeJS ainsi qu'un client web en React."
			],
			"link": "https://www.solu-tech.fr/"
		}, 
		{
			"name": "Solu-Tech",
			"loc": "Rosheim, France",
			"locLink": "https://goo.gl/maps/jejsTAkaHi52s8rg9",
			"date": "2018 (2 mois)",
			"desc": [
				"Mes premiers pas dans le monde de l'entreprise. Ici j'étais chargé de faire quelques missions, basés principalement autour de l'informatique industrielle.",
				"J'ai eu l'occasion de me former sur le PowerShell, le PHP ou encore le SQL...",
			],
			"link": "https://www.solu-tech.fr/"
		}
	],
	"skillsDescription": "Voici une liste de mes compétences et différents logiciels que je possède et utilise, au cours de mes études ou de la réalisation de projets personnels.",
	"skills": [
		{
			"name": "Anglais",
			"icon": "/images/skills/english.png",
			"linkText": "Niveau B2",
			"link": "https://www.efset.org/fr/english-score/cefr/b2/",
			"type": "",
			"text": [
				"J'apprends l'anglais au cours de mes études depuis le CM1.",
				"Je m'améliore quotidiennement en voyageant et en regardant toutes les séries TV que je suis en anglais.",
				"J'ai aussi obtenu le TOEIC avec 870 points sur 990."
			]
		},
		{
			"name": "Git",
			"icon": "/images/skills/git.png",
			"linkText": "Lien vers le site",
			"link": "https://git-scm.com/",
			"type": "Logiciels de gestion de version",
			"text": [
				"Il permet de simplifier au maximum le travail en équipe et d'éviter de s'occuper de la gestion de code."
			]
		},
		{
			"name": "Visual Studio Code",
			"icon": "/images/skills/vscode.png",
			"linkText": "Lien vers le site",
			"link": "https://code.visualstudio.com/",
			"type": "",
			"text": [
				"Cet éditeur de code à l'avantage d'être personnalisable et très léger.",
				"De plus il est compatible avec la plupart des langages.",
			]
		},
		{
			"name": "Trello",
			"icon": "/images/skills/trello.png",
			"linkText": "Lien vers le site",
			"link": "https://trello.com/home",
			"type": "Logiciel de productivité",
			"text": [
				"Cet outil permet à une équipe de créer des tableaux de tâches comportant plusieurs colonnes et de déplacer les tâches entre elles.",
				"Généralement, les colonnes incluent les statuts de tâches :",
				"À faire, En cours, Terminé."
			]
		},
		{
			"name": "Linux",
			"icon": "/images/skills/linux.png",
			"linkText": "En savoir plus...",
			"link": "https://fr.wikipedia.org/wiki/Linux",
			"type": "Système d'exploitation",
			"text": [
				"Je l'utilise principalement pour la gestion de l'environnement domotique à mon domicile.",
				"Plusieurs serveurs se chargent de la gestion des appareils, d'autres des fichiers et du multimédia, etc..."
			]
		},
		{
			"name": "Kubernetes",
			"icon": "/images/skills/kubernetes.png",
			"linkText": "Lien vers le site",
			"link": "https://kubernetes.io",
			"type": "Orchestration de conteneurs",
			"text": [
				"Grâce à mon expérience chez Numesia, j'ai appris à gérer des clusters Kubernetes.",
				"Cette technologie à l'avantage de faciliter grandement la gestion de nos pics d'utilisateurs et de nos applications."
			]
		},
		{
			"name": "Docker",
			"icon": "/images/skills/docker.png",
			"linkText": "Lien vers le site",
			"link": "https://www.docker.com",
			"type": "Conteneurs Logiciels",
			"text": [
				"Je place aujourd'hui l'intégralité de mes applications dans des conteneurs Docker.",
				"Ainsi, je peux gérer chacune d'entre-elles individuellement tout en sécurisant un maximum leur accès."
			]
		},
		{
			"name": "Android Studio",
			"icon": "/images/skills/android_studio.png",
			"linkText": "Lien vers le site",
			"link": "https://developer.android.com/studio/",
			"type": "",
			"text": [
				"Ce logiciel me permet de créer des applications Android et simuler un environnement dans la foulée.",
				"Il a l'avantage d'intégrer les outils Git et ADB."
			]
		},
		{
			"name": "Suite Office",
			"icon": "/images/skills/office.png",
			"linkText": "Lien vers le site",
			"link": "https://www.office.com/",
			"type": "Logiciels de traitement de texte, de présentation, etc...",
			"text": [
				"J'utilise la suite Office depuis la version 2003.",
				"J'ai donc aujourd'hui, d'assez bonnes connaissances sur les logiciels Word, PowerPoint, Excel, Visio,..."
			]
		},
		{
			"name": "Adobe Photoshop",
			"icon": "/images/skills/photoshop.png",
			"linkText": "Lien vers le site",
			"link": "https://www.adobe.com/fr/products/photoshop.html",
			"type": "Logiciel de graphisme",
			"text": [
				"J'utilise ce logiciel régulièrement afin de modifier ou de créer des images pour différentes occasions.",
				"Exemple : création de site web, d'interfaces, d'icônes, etc..."
			]
		},
		{
			"name": "Final Cut Pro",
			"icon": "/images/skills/finalcut.png",
			"linkText": "Lien vers le site",
			"link": "https://www.apple.com/fr/final-cut-pro/",
			"type": "Logiciel de montage vidéo",
			"text": [
				"Ce logiciel n'est qu'uniquement disponible sur Mac.",
				"Je l'utilise dès que j'ai une vidéo à monter que ce soit pour un projet ou un devoir à rendre."
			]
		}
	],
	"langagesDesc": "Voici les plateformes et différents langages et frameworks que j'utilise.",
	"langages": [
		{
			"name": "JavaScript / TypeScript",
			"icon": "/images/langages/js.png",
			"desc": "",
			"link": "https://fr.wikipedia.org/wiki/JavaScript",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "ReactJS",
			"icon": "/images/langages/react.png",
			"desc": "Framework Web",
			"link": "https://fr.wikipedia.org/wiki/React_(JavaScript)",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "Laravel",
			"icon": "/images/langages/laravel.png",
			"desc": "Framework Web",
			"link": "https://fr.wikipedia.org/wiki/Laravel",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "Java",
			"icon": "/images/langages/java.png",
			"desc": "",
			"link": "https://fr.wikipedia.org/wiki/Java_(langage)",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "PHP",
			"icon": "/images/langages/php.png",
			"desc": "",
			"link": "https://fr.wikipedia.org/wiki/PHP",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "Python",
			"icon": "/images/langages/python.png",
			"desc": "",
			"link": "https://fr.wikipedia.org/wiki/Python_(langage)",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "HTML",
			"icon": "/images/langages/html.png",
			"desc": "",
			"link": "https://fr.wikipedia.org/wiki/Hypertext_Markup_Language",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "CSS",
			"icon": "/images/langages/css.png",
			"desc": "",
			"link": "https://fr.wikipedia.org/wiki/Feuilles_de_style_en_cascade",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "C#",
			"icon": "/images/langages/csharp.png",
			"desc": "",
			"link": "https://fr.wikipedia.org/wiki/C_sharp",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "SQL",
			"icon": "/images/langages/sql.png",
			"desc": "Bases de données",
			"link": "https://fr.wikipedia.org/wiki/Structured_Query_Language",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "BASH",
			"icon": "/images/langages/bash.png",
			"desc": "Shell Script",
			"link": "https://fr.wikipedia.org/wiki/Bourne-Again_shell",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "SAS",
			"icon": "/images/langages/sas.png",
			"desc": "Bases de données décisionnelles",
			"link": "https://fr.wikipedia.org/wiki/SAS_Institute",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "C",
			"icon": "/images/langages/c.png",
			"desc": "",
			"link": "https://fr.wikipedia.org/wiki/C_(langage)",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "Android",
			"icon": "/images/langages/android.png",
			"desc": "OS Mobile",
			"link": "https://fr.wikipedia.org/wiki/Android",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "iOS",
			"icon": "/images/langages/ios.png",
			"desc": "OS Mobile",
			"link": "https://fr.wikipedia.org/wiki/iOS",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "macOS",
			"icon": "/images/langages/mac.png",
			"desc": "OS Desktop",
			"link": "https://fr.wikipedia.org/wiki/Mac_OS",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "Linux",
			"icon": "/images/langages/linux.png",
			"desc": "OS Desktop",
			"link": "https://fr.wikipedia.org/wiki/Linux",
			"linkTitle": "Wikipedia"
		},
		{
			"name": "Windows",
			"icon": "/images/langages/windows.png",
			"desc": "OS Desktop",
			"link": "https://fr.wikipedia.org/wiki/Microsoft_Windows",
			"linkTitle": "Wikipedia"
		}
	],
	"projectTitle": "Voici quelques-uns de mes projets",
	"projects": [{
		"name": "Plantae",
		"date": "2018",
		"desc": "Jeu éducatif",
		"link": "",
		"linkText": "Lien vers le projet",
		"git": "https://github.com/ThePrincelle/Plantae",
		"gitText": "Lien vers le Git",
		"imgurl": "/images/projects/t3.png",
		"tags": [
			["HTML", ""],
			["CSS", ""],
			["JS", ""],
			["PHP", ""],
			["Ratchet", "http://socketo.me"],
			["Bootstrap", "https://getbootstrap.com"]
		],
		"text": [
			"Ce projet a été réalisé dans le cadre du module T3 lors de mon DUT Informatique.",
			"Le sujet principal étant la botanique, le jeu consiste à tenir sa fleur en vie le plus longtemps possible.",
			"Le jeu se joue donc à deux, soit contre l'ordinateur, soit contre un adversaire en ligne."
		]
	}, {
		"name": "Accuracy Robots",
		"date": "2019",
		"desc": "Jeu éducatif (Prototype)",
		"link": "https://accuracyrobots.princelle.org",
		"linkText": "Lien vers le projet",
		"git": "https://github.com/ThePrincelle/Accuracy-Robots",
		"gitText": "Lien vers le Git",
		"imgurl": "/images/projects/t4.png",
		"tags": [
			["JS", ""],
			["HTML", ""],
			["CSS", ""],
			["React", "https://reactjs.org"],
			["React Bootstrap", "https://react-bootstrap.github.io"]
		],
		"text": [
			"Ce projet a été réalisé dans le cadre du module T4 lors de mon DUT Informatique.",
			"Le jeu se déroule en tour par tour. Le but est de garder son robot à un certain niveau d'intégrité afin qu'il n'explose pas.",
			"Le principe de ce jeu suit les lois d'Asimov."

		]
	}, {
		"name": "Cloud Princelle",
		"date": "2019",
		"desc": "Stockage en ligne",
		"link": "https://cloud.princelle.org",
		"linkText": "Lien vers le projet",
		"git": "",
		"gitText": "",
		"imgurl": "/images/projects/cloud.png",
		"tags": [
			["HTML", ""],
			["CSS", ""],
			["JS", ""],
			["PHP", ""]
		],
		"text": [
			"Après avoir cherché pendant longtemps une solution de stockage en ligne, j'ai décidé de créer mon propre service cloud.",
			"Basé sur le logiciel open source NextCloud, j'ai modifié ce dernier afin d'ouvrir ce service à plusieurs personnes pour permettre l'édition de documents en temps réel."
		]
	}, {
		"name": "Home",
		"date": "2018",
		"desc": "Logiciel de gestion domotique",
		"link": "https://home.princelle.org",
		"linkText": "Lien vers le projet",
		"git": "",
		"gitText": "",
		"imgurl": "/images/projects/home.png",
		"tags": [
			["Python", ""]
		],
		"text": [
			"Basé le logiciel open source Home Assistant, ce système me permet de créer une interface entre les appareils de mon domicile et les différents clients (mobiles, tablettes, assistants vocaux).",
			"Ce système, permet également les interactions et automatisations autour des appareils, que ce soit pour le chauffage, le multimédia, les luminaires,...",
			"J'ai également développé un système d'interaction unique pour tout les types de clients connectés au système, que ce soit SMS ou via la voix avec Google Assistant ou encore Siri."
		]
	}, {
		"name": "HomePrince",
		"date": "2019",
		"desc": "Projet - Création d'entreprise",
		"link": "https://homeprince.princelle.org",
		"linkText": "Lien vers le site",
		"git": "https://github.com/ThePrincelle/HomePrince-Website",
		"gitText": "Lien vers le Git",
		"imgurl": "/images/projects/homeprince.png",
		"tags": [
			["HTML", ""],
			["CSS", ""],
			["JS", ""],
			["PHP", ""],
			["Bootstrap", "https://getbootstrap.com"]
		],
		"text": [
			"Il s'agit d'une application réalisée dans le cadre du module E4a lors du DUT.",
			"L'idée était de créer une entreprise de notre choix et de mettre au point un business plan."
		]
	}, {
		"name": "Portfolio",
		"date": "2019",
		"desc": "CV en ligne",
		"link": "https://princelle.org",
		"linkText": "Lien vers le projet",
		"git": "https://github.com/ThePrincelle/Personal-Website",
		"gitText": "Lien vers le Git",
		"imgurl": "/images/projects/portfolio.png",
		"tags": [
			["JS", ""],
			["HTML", ""],
			["CSS", ""],
			["React", "https://reactjs.org"],
			["Modernizr", "https://modernizr.com"]
		],
		"text": [
			"Version 2.0. (3.0. en cours de développement, sortie prévue début juin 2022)",
			"Vous êtes dessus.",
			"Ce site présente qui je suis ainsi que les différents projets que j'ai réalisé."
		]
	}
	],
	"awardsDesc": [
		"Vous trouverez ici, les différentes récompenses que j'ai reçu lors des différents concours auquel j'ai participé."
	],
	"awards": [{
		"event": "24h des IUT",
		"name": "1ère place - Épreuve 'Intelligence Artificielle'",
		"loc": "Université Le Havre, France",
		"locLink": "https://goo.gl/maps/2BMVp4VK8sLuySDz9",
		"date": "Édition 2019",
		"desc": [
			"L'objectif était de construire un programme d'IA pour résoudre un problème donné.",
			"Afin de réaliser un programme performant, nous avons choisi Python comme language.",
			"Le principe était de réaliser une connexion en réseau à un serveur afin de pouvoir jouer contre ce dernier.",
			"Le but était de réaliser le programme le plus performant mais aussi avec la meilleure stratégie possible tout en respectant les règles données."
		],
		"linkDescAwards": "En apprendre plus sur l'évènement...",
		"link": "https://di.iut.univ-lehavre.fr/24hinfo/index.php"
	}],
	"contactDesc": "Vous souhaitez me poser une question ou autre ?",
	"contactWhere": "Où me trouver ?",
	"adress": [
		"49, Rue du fossé",
		"67280 Niederhaslach",
		"France"
	],
	"adressGMAPS": "https://goo.gl/maps/bQDsFxJ38kp",
	"phone": "+33 6 29 24 93 52",
	"phoneLink": "tel:+33629249352",
	"mail": "contact-maxime (at) princelle.org",
	"contactOther": "Me contacter",
	"formTitle": "M'envoyer un message.",
	"formNameLabel": "Votre nom",
	"formNamePlaceholder": "Insérez votre nom ici.",
	"formMailLabel": "Votre e-mail",
	"formMailPlaceholder": "Insérez votre e-mail ici.",
	"formSujetLabel": "Sujet",
	"formSujetPlaceholder": "Insérez ici l'objet de votre message",
	"formMsgLabel": "Message",
	"formMsgPlaceholder": "Insérez votre message ici.",
	"btnSend": "Envoyer",
	"emptyInputs": "Merci de remplir tous les champs.",
	"locCaptcha": "fr",
	"cvPDF_Msg": "CV en PDF",
	"cvPDF_File": "/CV - Maxime Princelle.pdf",
	"errorMsg": "Navré mais une erreur s'est produite lors de l'envoi de votre message. Nous vous invitons à réessayer.",
	"spamMsg": "Navré mais le service de vérification n'a pas validé votre message. Nous vous invitons à réessayer.",
	"successMsg": "Votre message a été envoyé avec succès."
};

export default resumeData;
